export default __webpack_public_path__ + "static/about_grow_bg_tn-eb2b74a192e0ada85eba71f5d05d9a3e.png";